import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class Testimonials extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    noticolor: "success",
    per_pge: 20,
    page_no: 1,
    redirect: false,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
  };

  componentDidMount() {
    this.getTestimonials(this.state.page_no, this.state.per_pge);
  }

  getTestimonials = (page = 1, limit = 20) => {
    if (init() === "success") {
      axios
        .get(`${Constants.getUrls.getAllTestimonials}?page=${page}&limit=${limit}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            const items = resp.data.data || [];
            const pag = resp.data.pagination || {};

            const currentPage = pag.page || page || 1;
            const perPage = pag.limit || limit || 10;
            const totalDocs = pag.total || items.length;
            const totalPages = pag.totalpage || Math.ceil(totalDocs / perPage) || 1;

            const hasNextPage =
              typeof pag.nextpage === "boolean" ? pag.nextpage : currentPage < totalPages;
            const hasPrevPage = typeof pag.prevpage === "boolean" ? pag.prevpage : currentPage > 1;

            const nextPage = hasNextPage && currentPage < totalPages ? currentPage + 1 : null;
            const prevPage = hasPrevPage && currentPage > 1 ? currentPage - 1 : null;

            this.setState({
              allJobs: Array.isArray(items) ? items : [],
              pagination: {
                page: currentPage,
                totalPages,
                hasNextPage,
                hasPrevPage,
                nextPage,
                prevPage,
                totalDocs,
                limit: perPage,
              },
              page_no: currentPage,
              notification: true,
              noticolor: "success",
              message: resp.data.message,
            });

            setTimeout(() => {
              this.setState({
                notification: false,
                message: "",
              });
            }, 2500);
          } else {
            this.setState({
              notification: true,
              noticolor: "error",
              message: resp.data.message,
            });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.message || "Error fetching testimonials",
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              message: "",
            });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState(
      {
        per_pge: newLimit,
      },
      () => {
        this.getTestimonials(1, newLimit); // reset to first page
      }
    );
  };

  handlePageChange = (newPage) => {
    this.getTestimonials(newPage, this.state.per_pge);
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteTestimonial + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              noticolor: "success",
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState(
                {
                  notification: false,
                  message: "",
                },
                () => {
                  this.getTestimonials(this.state.page_no, this.state.per_pge);
                }
              );
            }, 2500);
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.message || "Delete failed",
          });
          setTimeout(() => {
            this.setState(
              {
                notification: false,
                message: "",
              },
              () => {
                this.getTestimonials(this.state.page_no, this.state.per_pge);
              }
            );
          }, 2500);
        });
    } else {
      window.location.assign("/");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    }

    const { pagination } = this.state;

    return (
      <div>
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Testimonial List
                </MDTypography>
              </MDBox>
              <Grid item sm={4} px={2} align="right">
                <Link to="/addtestimonials">
                  <MDButton variant="contained" size="small" color="primary">
                    Create
                  </MDButton>
                </Link>
              </Grid>
              <MDBox>
                <DataTable
                  table={{
                    columns: [
                      { Header: "serial", accessor: "serial", width: "6%" },
                      { Header: "name", accessor: "name" },
                      { Header: "testimonial_from", accessor: "testimonial_from" },
                      { Header: "content", accessor: "content" },
                      { Header: "image", accessor: "image" },
                      { Header: "action", accessor: "action" },
                    ],
                    rows: this.state.allJobs.map((job, index) => ({
                      serial: (pagination.page - 1) * pagination.limit + (index + 1),
                      name: job.name,
                      testimonial_from: job.testimonial_from,
                      image: (
                        <img
                          src={Constants.imageDomain + job.image}
                          height="100px"
                          alt="Testimonial"
                        />
                      ),
                      content: job.content,
                      action: (
                        <>
                          <Link
                            to={{
                              pathname: "/updateTestimonial/" + job._id,
                              state: { data: job },
                            }}
                          >
                            <MDButton variant="outlined" size="small" color="info">
                              Update
                            </MDButton>
                          </Link>
                          <div style={{ marginTop: "1rem" }}>
                            <MDButton
                              variant="outlined"
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(job._id)}
                            >
                              Delete
                            </MDButton>
                          </div>
                        </>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_pge }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              </MDBox>
              <MDSnackbar
                color={this.state.noticolor}
                icon="notifications"
                title="ASA-Agrotech | Testimonials"
                content={this.state.message}
                dateTime="Just now"
                open={this.state.notification}
              />
            </Card>
          </MDBox>
        </DashboardLayout>
      </div>
    );
  }
}
